import { useState } from "react";

import processApi from "../../api/processApi";
import productTypeApi from "../../api/productTypeApi";
import useMount from "../../hooks/useMount";
import AlertModal from "../Commons/AlertModal";
import ActionButton from "../Commons/ActionButton";
import AdminProcessModal from "./AdminProcessModal";
import ListComponent from "../Commons/ListComponent";
import Pagination from "../Commons/Pagination";
import ListFilter from "../Commons/ListFilter";
import { applyListFilter, applyListSort, applyListFilterAndSort } from "../../tools/GeneralHelper";

import { getLabel, getLanguage } from "../../tools/Dictionary";


import { MdAdd } from "react-icons/md";


const AdminProcessCont = (props) =>
{
  
  //Props
  const IsDesktop = props.IsDesktop;
  const Access = props.Access;
  const ParentLoading = props.ParentLoading;
  const setParentLoading = props.setParentLoading;


  //State
  const [loading, setLoading] = useState(true);
  const [template, setTemplate] = useState([]);
  const [currentTemplate, setCurrentTemplate] = useState([]);
  const [productType, setProductType] = useState([]);
  const [column, setColumn] = useState([
    {
      label: getLabel("T_Process", "code"),
      property: "code",
      style: { width: "25%", minWidth: "50px" },
      isMobile: true,
      mobileStyle: { width: "25%", minWidth: "50px" },
      filterOperator: "like",
      filterValue: ""
    },
    {
      label: getLabel("T_Process", "description"),
      property: "description",
      style: { width: "50%", minWidth: "100px" },
      isMobile: true,
      mobileStyle: { width: "50%", minWidth: "50px" },
      filterOperator: "like",
      filterValue: ""
    },
    {
      label: getLabel("T_Process", "status"),
      property: "status.label",
      style: { width: "12%", minWidth: "50px" },
      isMobile: true,
      mobileStyle: { width: "25%", minWidth: "50px" },
      filterOperator: "like",
      filterValue: ""
    },
    {
      label: getLabel("T_Process", "isActive"),
      property: "isActive",
      style: { width: "13%", minWidth: "50px" },
      isMobile: true,
      mobileStyle: { width: "25%", minWidth: "50px" },
      format: "boolean",
      booleanValue: { true: getLabel("App", "Yes"), false: getLabel("App", "No")},
      filterOperator: "like",
      filterValue: ""
    }
  ]);
  const [sort, setSort] = useState({
    property: "",
    direction: 0 // Desc = 0, Asc = 1
  });
  const [pagination, setPagination] = useState({
    page: 1,
    perPage: 10
  });
  const [modal, setModal] = useState({
    id: 0,
    display: false
  });
  const [alert, setAlert] = useState({
    Title: "",
    Message: "",
    Confirm: "",
    onConfirm: () => void 0,
    Display: false
  });



  useMount(() => {
    loadData();
  }, []);

  const loadData = async (_showLoading = true, _id = 0) => {

    try{


      if (_id != 0){
        setModal(modal => ({
          ...modal,
          id: _id,
          duplicate: undefined
        }))
      }

      if (_showLoading){
        setParentLoading(true); 
        setLoading(true);
      }

      let [templateData, producTypeData] = await Promise.all([
        processApi.getProcesses({ select: "_id,code,description,isTemplate,isActive,status.code,status.label,updatedBy", translate: getLanguage().code }), 
        productTypeApi.getProductTypes({ filter: "isActive is true", select: `_id,label,isActive,order`, translate: getLanguage().code, sort: "order asc"})
      ]);

      if (templateData.Success){


        let loadedTemplate = applyListFilterAndSort(templateData.Data, column, sort);

        setTemplate(loadedTemplate);
        checkDataUpdateForPagination(loadedTemplate, pagination);


      }else
        throw new Error(templateData.Error.label);
      
      if (producTypeData.Success)
        setProductType(producTypeData.Data);
      else
        throw new Error(producTypeData.Error.label);



      setParentLoading(false);  
      setLoading(false);

    }catch(err){

      setParentLoading(false); 
      setLoading(false); 

      setAlert({
        Title: getLabel("App", "Error"),
        Message: err.message || getLabel("App", "Sorry, an unknown error has occurred. Please try again later or contact our support team for assistance."),
        Confirm: getLabel("App", "Ok"),
        onConfirm: () => setAlert(alert => ({ ...alert, Display: false })),
        Display: true
      });

    }

  };

  const checkDataUpdateForPagination = (_data, _pagination, _resetPage = false) =>
  {

    let tempData = _data.filter(d => !d.bFiltered);
    let maxPage = Math.ceil(tempData.length / _pagination.perPage);
    let currentPage = _pagination.page;

    if (_resetPage)
      currentPage = 1;
    else if (_pagination.page > maxPage)
    {
      currentPage = maxPage > 0 ? maxPage : 1;
    }

    setCurrentTemplate(sliceDataForPagination(_data, currentPage));

    setPagination(pagination => ({
      ...pagination,
      page: currentPage
    }));
  };

  const sliceDataForPagination = (_data, _page) =>
  {

    return _data.filter(d => !d.bFiltered).slice(pagination.perPage * (_page - 1), pagination.perPage * (_page - 1) + pagination.perPage);

  };

  const onClickSort = (_sort) =>
  {

    let tempData = applyListSort(template, _sort);

    setTemplate(tempData);
    checkDataUpdateForPagination(tempData, pagination);
    setSort(_sort);

  };

  const onApplyFilter = (_column) =>
  {

    let tempData = applyListFilter(template, _column);

    setTemplate(tempData);
    checkDataUpdateForPagination(tempData, pagination, true);
    setColumn(_column);

  };

  const onChangePage = (_page) =>
  {

    let tempPagination = {
      ...pagination,
      page: _page
    };

    checkDataUpdateForPagination(template, tempPagination);

  };


  const onClickItem = (_item) => {

    setModal({
      id: _item._id,
      display: true, 
      duplicate: undefined
    });

  };

  const onClickNew = () => {

    setModal({
      id: 0,
      display: true,
      duplicate: undefined
    })

  };

  const onDuplicate = async(_id) => {


    setModal({
      id: 0,
      display: true,
      duplicate: _id
    });

  };



  let currentLoading = loading || ParentLoading;


  return (
    <div className="page_body_cont">
      {modal.display && 
        <AdminProcessModal
          IsDesktop={IsDesktop}
          Id={modal.id}
          Duplicate={modal.duplicate}
          Access={Access}
          OnCloseModal={() => setModal({id: 0, display: false, duplicate: false })}
          ProductType={productType}
          LoadData={loadData}
          OnDuplicate={onDuplicate}
        />
      }
      <AlertModal
        Title={alert.Title}
        Message={alert.Message}
        Confirm={alert.Confirm}
        onConfirm={alert.onConfirm}
        Display={alert.Display}
      />
      <div className="page_action_cont" style={{width: "90%", maxWidth: "1200px"}}>
        <div className="page_action_section" style={{ width: "30%" }}>
          <ActionButton
            IsDesktop={IsDesktop}
            Label={getLabel("App", "New")}
            Icon={MdAdd}
            Disabled={currentLoading}
            OnClick={onClickNew}
          />
        </div>
        <div className="page_action_section" style={{ width: "40%", justifyContent: "center" }}>
          <Pagination
            IsDesktop={IsDesktop}
            data={pagination}
            onChangePage={onChangePage}
            count={template.filter(p => !p.bFiltered).length}
          />
        </div>
        <div className="page_action_section" style={{ width: "30%", justifyContent: "right" }}>
          <ListFilter
            IsDesktop={IsDesktop}
            column={column}
            Data={template}
            OnApplyFilter={onApplyFilter}
          />
        </div>
      </div>

      <ListComponent 
        IsDesktop={IsDesktop}
        Column={column}
        Data={currentTemplate}
        Sort={sort}
        ListStyle={{width: "90%", maxWidth: "1200px"}}
        Loading={loading}
        Debug={false}
        OnClickSort={onClickSort}
        OnClickItem={onClickItem}
      />

    </div>
  );

}


export default AdminProcessCont;